export default "__VITE_ASSET__C2HYtCK6__"